import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getCompanyList = createAsyncThunk('/thunk/get-company-list', async () => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-company-list`,{page:1})
        return response
    } catch (error) {
        throw error
    }
});